export enum MapTypeEnum {
    road = "road",
    satellite_road_labels = "satellite_road_labels",
    satellite = "satellite",
    road_shaded_relief = "road_shaded_relief"
}